/* Auto generated by gulp-typescript-template */

export const ChapterImage = ` <img class="image-responsive [[ style ]] [[{ 'hidden':style != '-full' }]]" src="[[ this.imageUri( asset, 'large', 'png') ]]"><div class="chapter-image [[{ 'hidden':style != '-original' }]]"> <img class="image" src="[[ this.imageUri( asset, 'original', asset.ext ) ]]"></div>`;
